import { PUSH_NOTIFICATION_VISIBILITY_STORAGE_KEY } from 'components/templates/AuthenticationProvider/Types';
import useLocalStorageState from 'hooks/useLocalStorageState';
import { useCallback } from 'react';

export type LocalStorageProps = {
  isVisible: boolean | null;
  expDate: number;
};

const getDefaultValue = (): LocalStorageProps => ({
  isVisible: true,
  expDate: 0,
});

const getExpiryInDays = (days: number): number => {
  const now = new Date();
  now.setDate(now.getDate() + days);
  return now.getTime();
};

export function usePushNotificationVisibility() {
  const [visibility, setVisibility] = useLocalStorageState<LocalStorageProps>(
    PUSH_NOTIFICATION_VISIBILITY_STORAGE_KEY,
    getDefaultValue,
    {},
  );

  const hideForDays = useCallback(
    (days: number) => {
      setVisibility({
        isVisible: false,
        expDate: getExpiryInDays(days),
      });
    },
    [setVisibility],
  );

  return {
    visibility,
    setVisibility,
    hideForDays,
  };
}
